export default (editor, config = {}) => {
  const bm = editor.BlockManager;
  const pfx = 'emp-twitter';
  const style = `<style>
    
      .content_iframe{
          height: 100%;
     }
  </style>`;
  bm.add('social-icons-twitter', {
    label: 'Twitter',
    category: 'Social',
    content: `<div data-gjs-type="social-icons-twitter">
<div class="content_iframe gjs-no-pointer">                
<a href="https://twitter.com/twitter" class="twitter-timeline gjs-no-pointer" id ="twitt_widget_new">Tweet</a><script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>
 </div>
              </div>
               ${style}
            `,

    attributes: {
      class: 'fa fa-twitter' //icon in the panel
    }
  });
};



// WEBPACK FOOTER //
// ./src/plugins/twitter/blocks.js